import { Box, Grid } from '@material-ui/core'
import { useFetch } from 'hooks'
import {
  User as UserIcon,
  Check as CheckIcon,
  Moon as MoonIcon,
} from 'react-feather'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { reverse } from 'named-urls'

import {
  Page,
  Container,
  ContentHeader,
  LoadingFeedback,
  StatusCard,
} from 'components'
import { ProfilesForm, ProfilesChangeStatus } from 'components/Profiles'

import constants from 'constants/index'
import * as service from 'service'
import palette from 'theme/palette'
import { routes } from 'Routes'

const UserProfilesEdit = ({ match }) => {
  const { pathname } = useLocation()

  const { userProfileId } = match.params

  const isAdvisor =
    pathname ===
    reverse(routes.userProfiles.editOrganizations, {
      userProfileId,
    })

  const profileGetRoute = isAdvisor
    ? service.backoffice.advisorProfiles.get
    : service.backoffice.userProfiles.get

  const { response, isLoading, refresh } = useFetch(profileGetRoute, {
    profileId: userProfileId,
  })

  const profile = response?.data?.profile

  return (
    <Page title="Edição de perfil">
      <LoadingFeedback open={isLoading} />
      <Container
        maxWidth={false}
        spacingXl={30}
        spacingLg={25}
        spacingMd={10}
        spacingSm={10}
      >
        <ContentHeader
          title="Edição"
          menu={`Perfis ${isAdvisor ? 'Advisor' : 'de usuário'}`}
          subtitle={`Edição de perfil ${isAdvisor ? 'advisor' : 'de usuário'}`}
        >
          <ProfilesChangeStatus
            isCollaborator={false}
            isAdvisor={isAdvisor}
            profile={profile}
            reloadProfile={refresh}
          />
        </ContentHeader>
        {!isLoading && (
          <Box width="100%" mt={4}>
            <Box mb={4}>
              <Grid container spacing={2}>
                <StatusCard
                  backgroundIconColor={palette.primary.main}
                  icon={<UserIcon color={palette.white} />}
                  label="Usuários vínculados"
                  value={String(profile?.linkedUsers)}
                />
                <StatusCard
                  backgroundIconColor={
                    profile?.status
                      ? palette.greenPantone
                      : palette.secondary.light
                  }
                  icon={
                    profile?.status ? (
                      <CheckIcon size={18} color="white" />
                    ) : (
                      <MoonIcon size={18} color="white" />
                    )
                  }
                  label="Status"
                  value={profile?.status ? 'Ativo' : 'Inativo'}
                />
              </Grid>
            </Box>
            <ProfilesForm
              profileType={
                isAdvisor
                  ? constants.user.PROFILE_TYPE_ADVISOR
                  : constants.user.PROFILE_TYPE_CLIENT
              }
              isEdit
              profile={profile}
            />
          </Box>
        )}
      </Container>
    </Page>
  )
}

export default UserProfilesEdit
